import { z } from 'zod'

export const ActivityStatusDtoSchema = z.union([z.literal('Active'), z.literal('Inactive'), z.literal('Used')])

export type ActivityStatusDto = z.infer<typeof ActivityStatusDtoSchema>

export const isActivityStatusDto = (x: unknown): x is ActivityStatusDto => ActivityStatusDtoSchema.safeParse(x).success
